export default {
    selectRoot(resources, response) {
        return resources.get(response.requestedUri);
    },
};
//# sourceMappingURL=ExactIdMatchSelector.js.map